import React from "react";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { FaFacebookF, FaGoogle, FaUsers } from "react-icons/fa";
import { SITE, NAV_ITEMS, buildWhatsAppLink } from "../mock/mock";

const Footer = () => {
  const handleNav = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#071b34] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-black text-2xl tracking-tight">{SITE.name}</div>
            <div className="text-[#FFC93C] font-bold text-xs tracking-widest mt-1">{SITE.tagline}</div>
            <p className="mt-4 text-white/70 max-w-md leading-relaxed">
              Excursions authentiques en mer au départ de la Marina du Gosier.
              Découvrez le Grand Cul-de-Sac Marin, ses îlets et sa mangrove avec un
              équipage local passionné.
            </p>
            <div className="mt-5 flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full bg-[#1877F2] flex items-center justify-center hover:scale-110 transition">
                <FaFacebookF className="h-4 w-4" />
              </a>
              <a href="#apropos" onClick={(e)=>{e.preventDefault();handleNav('apropos');}} className="h-10 w-10 rounded-full bg-[#25D366] flex items-center justify-center hover:scale-110 transition">
                <FaUsers className="h-4 w-4" />
              </a>
              <a href="https://google.com" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full bg-white flex items-center justify-center hover:scale-110 transition">
                <FaGoogle className="h-4 w-4 text-[#4285F4]" />
              </a>
            </div>
          </div>

          <div>
            <div className="font-bold text-[#FFC93C] text-sm tracking-widest">NAVIGATION</div>
            <ul className="mt-4 space-y-2">
              {NAV_ITEMS.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => handleNav(n.id)}
                    className="text-white/70 hover:text-[#FFC93C] transition text-sm"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-bold text-[#FFC93C] text-sm tracking-widest">CONTACT</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2 text-white/80">
                <MapPin className="h-4 w-4 shrink-0 mt-0.5 text-[#25D366]" />
                {SITE.address}
              </li>
              <li>
                <a href={`tel:+590${SITE.phoneRaw.substring(1)}`} className="flex items-center gap-2 text-white/80 hover:text-[#FFC93C] transition">
                  <Phone className="h-4 w-4 text-[#25D366]" />
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 text-white/80 hover:text-[#FFC93C] transition break-all">
                  <Mail className="h-4 w-4 text-[#25D366]" />
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={buildWhatsAppLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-bold px-4 py-2 rounded-full text-sm transition"
                >
                  <MessageCircle className="h-4 w-4" fill="white" strokeWidth={0} />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} GwadaPlaisance — Tous droits réservés.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white transition">Mentions légales</a>
            <a href="#" className="hover:text-white transition">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
